function savedSearchService(
  $http,
  $q,
  _,
  filtersService,
  $location,
  analyticsService) {
  const service = {
    apiUrl: 'api/user/searches'
  };

  service.getAll = () => {
    const deferred = $q.defer();

    $http.get(`${service.apiUrl}?type=content&size=50`)
      .success((data) => {
        deferred.resolve(data);
      })
      .error((response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.get = (id) => {
    const deferred = $q.defer();

    $http.get(`${service.apiUrl}/${id}`)
      .success((data) => {
        deferred.resolve(data);
      })
      .error((response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.getById = async (id) => {
    try {
      const response = await $http.get(`api/searches/${id}`);
      return response.data;
    } catch (err) {
      return err.data;
    }
  };

  service.getDefault = () => $http.get('api/user')
    .then((response) => {
      const { preferences } = response.data;
      return preferences && preferences.defaultSavedSearch ? preferences.defaultSavedSearch : null;
    });

  service.update = (savedSearch) => {
    const deferred = $q.defer();

    $http({
      method: 'PUT',
      url: `${service.apiUrl}/${savedSearch.id}`,
      data: savedSearch
    })
      .success((data) => {
        analyticsService.trackEvent('Saved search management', 'Updated saved search');
        deferred.resolve(data);
      })
      .error((response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.create = (savedSearch) => {
    const deferred = $q.defer();

    $http({
      method: 'POST',
      url: service.apiUrl,
      data: savedSearch
    })
      .success((data) => {
        analyticsService.trackEvent('Saved search management', 'Created saved search');
        deferred.resolve(data);
      })
      .error((response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.delete = (savedSearch) => {
    const deferred = $q.defer();

    $http.delete(`${service.apiUrl}/${savedSearch.id}`)
      .success((data) => {
        analyticsService.trackEvent('Saved search management', 'Deleted saved search');
        deferred.resolve(data);
      })
      .error((response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.processRawSearch = (rawSearch) => {
    const search = rawSearch;

    if (search.params.paths) {
      delete search.params.paths;
    }

    if (search.params.primaryWebsites) {
      search.params.websites = search.params.primaryWebsites;
    }

    if (_.isArray(search.params.pitchStatus)) {
      if (search.params.pitchStatus && search.params.pitchStatus.length === 5 &&
        search.params.section && search.params.section.length) {
        search.params.limitToPitches = true;
      } else if (search.params.platforms && search.params.platforms.length) {
        delete search.params.limitToPitches;
      }
    }

    if (search.params.content) {
      search.params.sponsored = search.params.content;
      delete search.params.content;
    }

    search.filters = _.reduce(search.params, (resultObj, param, paramName) => {
      const result = resultObj;
      if (param && filtersService.availableFilters[paramName]) {
        const filter = angular.copy(filtersService.availableFilters[paramName]);
        filter.value = param || filter.fallback;
        filter.name = paramName;
        result[paramName] = filter;
      }
      return result;
    }, {});

    return search;
  };
  service.applySearch = (search) => {
    const filters = service.processDates(search);
    const queryParams = filtersService.FilterSet.prototype.buildQueryParams(filters);
    analyticsService.trackEvent('Saved search management', 'Applied saved search');
    /**
    * Prevent fallback `websites` filter from being applied,
    * if the saved search explicitly excludes this parameter;
    * see `filtersService.availableFilters.websites.fallback`
    */
    if (!queryParams.websites) {
      queryParams.websites = [];
    }
    $location.search(queryParams);
  };

  service.returnQueryParams = (search) => {
    const filters = service.processDates(search);
    const queryParams = filtersService.FilterSet.prototype.buildQueryParams(filters);
    analyticsService.trackEvent('Saved search management', 'Return Homepage Saved Search Query Params');
    return queryParams;
  };

  service.processDates = (search) => {
    const filters = angular.copy(search).filters;
    if (filters.startDate && filters.startDate.value && (filters.startDate.value.special ||
      filters.startDate.value.relative)) {
      filters.startDate.value = filters.startDate.value.special || (filters.startDate.value.relative > 0 ? `+${filters.startDate.value.relative}` : filters.startDate.value.relative.toString());
    } else if (filters.startDate && filters.startDate.value && typeof filters.startDate.value !== 'object') {
      const startDate = filters.startDate.value.toString();
      if (startDate.charAt(0) === '+' || startDate.charAt(0) === '-') {
        filters.startDate.value = { relative: filters.startDate.value };
      }
    } else {
      filters.startDate = { value: null };
    }

    if (filters.endDate && filters.endDate.value && (filters.endDate.value.special ||
      filters.endDate.value.relative)) {
      filters.endDate.value = filters.endDate.value.special ||
        (filters.endDate.value.relative > 0 ?
          `+${filters.endDate.value.relative}` : filters.endDate.value.relative.toString());
    } else if (filters.endDate && filters.endDate.value && typeof filters.endDate.value !== 'object') {
      const endDate = filters.endDate.value.toString();
      if (endDate.charAt(0) === '+' || endDate.charAt(0) === '-') {
        filters.endDate.value = { relative: filters.endDate.value };
      }
    } else {
      filters.endDate = { value: null };
    }

    return filters;
  };

  return service;
}

const arr = [
  '$http',
  '$q',
  '_',
  'filtersService',
  '$location',
  'analyticsService',
  savedSearchService
];

module.exports = (ngModule) => {
  ngModule.factory('savedSearchService', arr);
};
